import { useEffect, useState } from "react";
import { apiGet } from "../utils/api";
import { ExploreCenterCard } from "./subcomponents/ExploreCenterCard";
import { PageSectionHeader } from "./subcomponents/PageSectionHeader";
import { routes } from "../utils/utils.routes";
import { PageSkeleton } from "./PageSkeleton";

type ExploreCentersProps = {
  showHeader?: boolean;
};

export const ExploreCenters: React.FC<ExploreCentersProps> = ({ showHeader = true }) => {
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiGet("/centers")
      .then((d) =>
        setItems(
          (d.rows || []).map((c: any) => ({
            flug: c.slug,
            title: c.title,
            images: c.images || [],
            href: `${routes.CENTRES}/${c.slug}`,
            description: c.description,
            domaineInterventions: c.domaineInterventions || [],
            direction: c.direction,
            profile: c.profile,
            partenaires: c.partenaires || [],
            etudesRealisees: c.etudesRealisees || [],
            contacts: c.contacts || [],
          }))
        )
      )
      .finally(() => setLoading(false));
  }, []);

  return (
    <div id="explore" className="has-global-padding is-layout-constrained is-layout-container">
      {showHeader && (
        <PageSectionHeader
          eyebrow="Recherche"
          title="Nos centres de recherche"
          lead="Ancrée dans l'excellence académique, notre université déploie une recherche d'avant-garde à travers des centres spécialisés couvrant l'ensemble de nos filières. De l'innovation technologique à la santé, en passant par les sciences juridiques, économiques et humaines, nos pôles d'expertise transforment le savoir en solutions concrètes pour la société."
          align="start"
        />
      )}

      {loading ? (
        <PageSkeleton />
      ) : items.length === 0 ? (
        <p className="page-empty-message">Aucun centre publié pour le moment.</p>
      ) : (
        <div className="explore-grid" data-testid="centers-grid">
          {items.map((item, index) => (
            <ExploreCenterCard key={index} {...item} />
          ))}
        </div>
      )}
    </div>
  );
};
